<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Preços por canal de venda</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>

      <div class="c-modalCard__body">
        <div class="l-row saleChannel" v-for="saleChannel in salesChannel">
          <div class="margin l-col-4@md">
            <strong class="ds-block">{{ $t('saleChannel.label') }}</strong>
            {{ saleChannel.label }}
          </div>
          <div class="l-col-12@md">
            <price :price= "saleChannel.price" columnSize="4"></price>
          </div>
        </div>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn btn--info" @click="close">Fechar</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import Price from '@/components/marketplace/shared/Price'

  export default {
    data: () => ({
      modal: null,
      isVisible: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      salesChannel: {
        type: Array,
        required: true
      }
    },
    created () {
      this.isVisible = this.value
    },
    updated () {
      this.modal = document.querySelector('div.c-modal')

      if (this.modal !== null) {
        this.modal.onclick = (event) => {
          if (event.target === this.modal) {
            this.close()
          }
        }
        document.body.onkeyup = (event) => {
          if (event.code === 'Escape') {
            this.close()
          }
        }
      }
    },
    methods: {
      close (emit) {
        delete document.body.onkeyup
        delete this.modal.onclick

        this.isVisible = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    },
    components: {
      Panel,
      Price
    }
  }
</script>

<style lang="sass" scoped>
  strong
    display: block

  .saleChannel
    margin-top: 16px
    padding: 10px

    &:not(:last-child)
      margin-bottom: 16px
      border-bottom: 1px solid #c2c2c2
      padding-bottom: 16px

  .margin
    margin-bottom: 15px
</style>



// WEBPACK FOOTER //
// ModalSalesChannelPrice.vue?9f9b85ee